import { useTranslation } from 'react-i18next'

import { Divider, Text } from '@reveni-io/reveni-ui'

import Integration from '../Integration/Integration'
import * as Styles from './styles'

const IntegrationsConnected = ({ integrations, onToggle, onUninstall, handleEditIntegration, disabled }) => {
  const { t } = useTranslation()

  if (!integrations || integrations.length === 0) return null
  return (
    <>
      <Divider />
      <Text type="titleS">{t('Conectado')}</Text>
      <Styles.IntegrationsContainer>
        {integrations.map(integration => (
          <Integration
            key={integration.id}
            integration={integration}
            onToggle={onToggle}
            onUninstall={onUninstall}
            onEdit={handleEditIntegration}
            disabled={disabled}
          />
        ))}
      </Styles.IntegrationsContainer>
    </>
  )
}

export default IntegrationsConnected
